import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FamiliarEditPageRoutingModule } from './familiar-edit-routing.module';
import { FamiliarEditPage } from './familiar-edit.page';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    PipesModule,
    FamiliarEditPageRoutingModule
  ],
  declarations: [FamiliarEditPage]
})
export class FamiliarEditPageModule {}
